import { createContext } from "react";

const ThemeSettingContext = createContext({});

export default ThemeSettingContext;
